import { render, staticRenderFns } from "./AudioTool.vue?vue&type=template&id=3f7c5869"
import script from "./AudioTool.vue?vue&type=script&lang=js"
export * from "./AudioTool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports